<div mat-dialog-title class="dialog-header">
  <h2 class="dialog-title">Export Options</h2>
  <button
    mat-icon-button
    mat-dialog-close
    (click)="onClose()"
    aria-label="Close dialog"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="export-content">
  <form class="export-form">
    <div class="form-row">
      <div class="date-picker">
        <label for="delivery-date" class="required-label">
          Date (required)</label
        >
        <div class="date-dropdown">
          <mat-form-field appearance="outline">
            <mat-select
              [(ngModel)]="dateType"
              name="dateType"
              placeholder="Select Date field"
            >
              <mat-option value="DELIVERY_DATE">Delivery Date</mat-option>
              <mat-option value="REVIEW_DATE">Review Date</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <input
              matInput
              id="delivery-date"
              [value]="displayedDateFilter"
              placeholder="Choose date or range"
              readonly
              (click)="openDateFilterDialog()"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="openDateFilterDialog()"
              aria-label="Open custom date filter"
            >
              <mat-icon>calendar_today</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="form-row toggle-row">
      <label for="quality-check">Quality Check</label>
      <mat-slide-toggle id="quality-check"></mat-slide-toggle>
    </div>

    <div class="form-row">
      <label for="member-id">Member ID</label>
      <mat-form-field appearance="outline">
        <input matInput id="member-id" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <label for="analyst">Analyst</label>
      <mat-form-field appearance="outline">
        <mat-select id="analyst" placeholder="Select Analyst">
          <mat-option value="1">Analyst 1</mat-option>
          <mat-option value="2">Analyst 2</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row">
      <label for="quality-analyst">Quality Analyst</label>
      <mat-form-field appearance="outline">
        <mat-select id="quality-analyst" placeholder="Select Quality Analyst">
          <mat-option value="1">QA 1</mat-option>
          <mat-option value="2">QA 2</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="onClose()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    class="export-submit"
    [disabled]="!isDeliveryDateValid"
    (click)="onExport()"
  >
    Export
  </button>
</mat-dialog-actions>
